import { render } from "./CheckoutSuccessThanks.vue?vue&type=template&id=c6e9d7c2&ts=true"
import script from "./CheckoutSuccessThanks.vue?vue&type=script&lang=ts"
export * from "./CheckoutSuccessThanks.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__